import { sanitize } from '@luna/utils';

import { stripHashAndSlash } from './hash/hashUtils';

const urlPathSeparator = '/';

/**
 * Takes a path such as #accounts/AT3552/overview and returns 'accounts/:id/overview'.
 * An assumption is that the ids that we put into the URL
 * contain either a digit or a capital letter.
 * ignorePaths are the paths which we do not want to normalize. Eg. 'shop/plugins/
 * where for example we do not want to normalize shop/plugins/PI-PRO into shop/plugins/:id
 * */
export function normalizePath(path = '', ignorePaths: string[] = []): string {
    if (!path) {
        return '';
    }
    const sanitizedPath = stripHashAndSlash(sanitize(path));
    const pathWithoutQuery = removeSearchQuery(sanitizedPath);

    const pathMatchesIgnorePath = ignorePaths.some((ignorePath) =>
        sanitizedPath.startsWith(stripHashAndSlash(ignorePath)),
    );
    if (pathMatchesIgnorePath) {
        return pathWithoutQuery;
    }

    return pathWithoutQuery.split(urlPathSeparator).map(normalizeIdInPath).join(urlPathSeparator);
}

function normalizeIdInPath(pathChunk: string): string {
    if (!hasNumber(pathChunk) && !hasCapitalLetter(pathChunk)) {
        return pathChunk;
    }

    return ':id';
}

function hasNumber(string: string): boolean {
    return /\d/.test(string);
}

function hasCapitalLetter(string: string): boolean {
    return /^[A-Z](.*?)$/.test(string);
}

function removeSearchQuery(path: string): string {
    return path.split('?')[0];
}
